export default function StyleHelpers ()
{
  const getCurrentStyleUnitNormalizer = (bigStr, digs, unit) =>
  {
    return Math.round(this.currentStyleUnitNormalizer(digs, unit)) + 'px';
  };


  const valueNormalizerFake = (value) =>
  {
    return value || null;
  };


  const intValueNormalizer = (value) =>
  {
    return parseInt(value, 10) || 0;
  };


  this.getElementRealBackground = (element, pWindow) =>
  {
    let currentStyle = {},
        currentStyleStr,
        currentStyleImage;

    do
    {
      currentStyle.backgroundColor = this.getElementStyle(element, 'backgroundColor', pWindow);

      if (!currentStyle.backgroundColor)
      {
        break;
      }

      currentStyleImage = this.getElementStyle(element, 'backgroundImage', pWindow);

      if (currentStyleImage && currentStyleImage.toLowerCase() !== 'none')
      {
        currentStyle = this.getElementStyles(
          element,
          [
            'backgroundRepeat',
            'backgroundPosition',
            'backgroundSize',
            'backgroundAttachment',
            'backgroundOrigin',
            'backgroundClip'
          ],
          pWindow
        );

        currentStyle.backgroundImage = currentStyleImage;
      }

      currentStyleStr = (currentStyle.backgroundColor || '').replace(/\s+/g, '').toLowerCase();
      element = element.parentNode;
    }
    while (element && element.nodeType === 1 && (currentStyleStr === 'rgba(0,0,0,0)' || currentStyleStr === 'transparent'));

    return currentStyle;
  };


  this.getElementStyle = (element, att, pWindow) =>
  {
    //pWindow = pWindow || window; //TODO:Dime fix FF bugs in editor iframe
    pWindow = window;              //TODO:Dime fix FF bugs in editor iframe

    let computedStyle,
        result = null;

    try
    {
      if (!element || !element.nodeType)
      {
        return null;
      }
    }
    catch (err)
    {
      return null;
    }

    if (element.nodeType === 9 && element.body)
    {
      element = element.body;
    }

    if (pWindow.document && pWindow.getComputedStyle && typeof(pWindow.getComputedStyle) === 'function' && element.nodeType === 1)
    {
      computedStyle = pWindow.getComputedStyle(element, null);

      if (computedStyle == null && element.style)
      {
        computedStyle = element.style;
      }

      result = computedStyle ? computedStyle[att] : null;
    }
    else if (element.currentStyle && element.nodeType === 1)
    {
      result = element.currentStyle[att];

      if (typeof(result) === 'string')
      {
        result = result.replace(/(\d+\.?\d*|\.\d+)(em|pt|%)/i, (bigStr, digs, unit) =>
        {
          let num = parseFloat(digs);

          switch (unit.toLowerCase())
          {
            case 'em':
              num *= 13.333;
              break;

            case 'pt':
              num *= 1.3333;
              break;

            case '%':
              num *= 0.1333;
              break;
          }

          return Math.round(num) + 'px';
        });
      }
    }

    return result;
  };


  this.currentStyleUnitNormalizer = (value, unit) =>
  {
    let num = parseFloat(value);

    switch (unit.toLowerCase())
    {
      case 'em':
        num *= 13.333;
        break;

      case 'pt':
        num *= 1.3333;
        break;

      case '%':
        num *= 0.1333;
        break;
    }

    return num;
  };


  this.currentStyleValueNormalizer = (value) =>
  {
    if (typeof value !== 'string') { return value; }

    return value.replace(/(\d+\.?\d*|\.\d+)(em|pt|%)/i, getCurrentStyleUnitNormalizer);
  };


  this.getElementStyles = (element, attr, pWindow, convertToInt) =>
  {
    //pWindow = pWindow || window; //TODO:Dime fix FF bugs in editor iframe
    pWindow = window;              //TODO:Dime fix FF bugs in editor iframe

    let computedStyle,
        result = {},
        i,
        length,
        currentAttr,
        valueNormalizer,
        elementNodeType,
        defaultValue = convertToInt ? 0 : null,
        valueConverter = convertToInt ? intValueNormalizer : valueNormalizerFake;

    for (i = 0, length = attr.length; i < length; i++)
    {
      currentAttr = attr[i];
      result[currentAttr] = defaultValue;
    }

    try
    {
      if (!element) { return result; }

      elementNodeType = element.nodeType;

      if (!elementNodeType) { return result; }
    }
    catch (err)
    {
      return result;
    }

    if (elementNodeType === 9 && element.body)
    {
      element = element.body;
      elementNodeType = element.nodeType;
    }

    if (elementNodeType === 1)
    {
      if (pWindow.document && typeof(pWindow.getComputedStyle) === 'function')
      {
        computedStyle = pWindow.getComputedStyle(element, null);

        if (computedStyle == null)
        {
          computedStyle = element.style;
        }

        valueNormalizer = valueNormalizerFake;
      }
      else
      {
        computedStyle = element.currentStyle;
        valueNormalizer = this.currentStyleValueNormalizer;
      }
    }

    if (computedStyle)
    {
      for (i = 0, length = attr.length; i < length; i++)
      {
        currentAttr = attr[i];
        result[currentAttr] = valueConverter(valueNormalizer(computedStyle[currentAttr]));
      }
    }

    return result;
  };


  this.getElementStyleStrictInt = (element, att, pWindow) =>
  {
    const compStyle = this.getElementStyle(element, att, pWindow),
          compStyleInt = (compStyle != null) ? parseInt(compStyle) : null;

    return (isNaN(compStyleInt) ? null : compStyleInt);
  };


  this.getElementStyleInt = (element, att, pWindow) =>
  {
    const compStyleInt = this.getElementStyleStrictInt(element, att, pWindow);
    return ((compStyleInt === null) ? 0 : compStyleInt);
  };
}